import { createTheme } from '@mui/material/styles';
import PoppinsFont from "../../files/fonts/poppins-regular-webfont.woff2";


const Poppins = {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
    local('Poppins'),
    local('Poppins'),
    url(${PoppinsFont}) format('woff2')`
};

export let theme = createTheme({
    palette: {
        primary: {
            main: '#F0051F',
        },
        secondary: {
            main: '#489E21',
        },
        field: {
            main: "#212121",
        },
        text:{
            main: "#212121",
        },
        gray:{
            main: "#eee",
        },
        grayDark:{
            main: "#666666",
        },
        lightRed:{
            main:"#fdf4f5"
        },
    },
    typography: {
        fontFamily: 'Poppins, Tahoma',
        lineHeight: 1.8,
        htmlFontSize: 19,
        h5: {
            fontSize: '20px',
            fontWeight: 'bold',
            color: '#333',
            lineHeight: 1.2,
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [Poppins],
            },

        },

    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontSize:'14px',
                    boxShadow:'none'
                },
                sizeLarge: {
                    lineHeight: '2.5',
                },
            },
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: '12px',
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    padding:"8px 15px",
                    "& .MuiAlert-action":{
                        paddingTop:0
                    }
                },

            },
        },
    },
    direction: 'ltr',
});